import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import {reposPickerDefinitionsPath} from '../paths'
import type {PickerScope, PropertyDefinition} from '../types'

const DEFINITIONS_STALE_TIME_IN_MS = 1000 * 60 * 5 // 5 minutes

export function useQueryDefinitions({scope, enabled = true}: {scope: PickerScope; enabled?: boolean}) {
  const isBizOrOrg = scope.type === 'enterprise' || scope.type === 'organization'

  return useQuery<PropertyDefinition[]>({
    queryKey: ['repos-picker', 'definitions', scope],
    enabled: isBizOrOrg && enabled,
    queryFn: async () => {
      const fetchDefinitionsUrl = reposPickerDefinitionsPath(scope)

      const response = await verifiedFetchJSON(fetchDefinitionsUrl)
      if (!response.ok) return []

      const responseData = await response.json()
      return responseData.definitions
    },
    staleTime: DEFINITIONS_STALE_TIME_IN_MS,
  })
}
